import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Header/Sidebar"
import Header from "./components/Header/Index"
import HeaderLogin from "./components/Header/HeaderLogin"
import StickyHeaderMenu from "./components/Header/StickyHeaderMenu";
import './Layout.css'
import NotificationPopover from './components/Header/NotificationPopover'
import Footer from "components/Footer";
import MobileSidebarDrawer from './components/Header/MobileSidebarDrawer'
import MobileSidebarDrawerNoneLogin from "components/Header/MobileSidebarDrawerNoneLogin";

export default function DashboardLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [notifyOpen, setNotifyOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('token') ? true : false);
  return (
    <div>
      <Sidebar onToggleNotify={() => setNotifyOpen(prev => !prev)} />

      <div>
        {!isLoggedIn && (
          <HeaderLogin onLoginSuccess={() => {
            setIsLoggedIn(true);
            window.location.reload();
          }} onOpenMenu={() => setDrawerOpen(true)} />
        )}
        {isLoggedIn && (
          <Header onOpenMenu={() => setDrawerOpen(true)} />
        )}
        {isLoggedIn && (
          <StickyHeaderMenu />
        )}
        <main>
          <Outlet />
        </main>
      </div>
      <Footer />
      {isLoggedIn && (
        <MobileSidebarDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        />
      )}
      {!isLoggedIn && (
        <MobileSidebarDrawerNoneLogin
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        />
      )}
      <NotificationPopover
        open={notifyOpen}
        onClose={() => setNotifyOpen(false)}
      />
    </div>
  )
}